import {
  Invitation,
  InvitationWithDestinationDetails,
} from 'models/invitations';
import { apiV2 } from './axios';

export const listInvitations = async (): Promise<
  InvitationWithDestinationDetails[]
> => {
  const { data } = await apiV2.get<InvitationWithDestinationDetails[]>(
    'invitations',
  );
  return data;
};

export const getInvitationById = async (
  id: string,
): Promise<InvitationWithDestinationDetails | undefined> => {
  const { data } = await apiV2.get<InvitationWithDestinationDetails>(
    `invitations/${id}`,
  );
  return data;
};

export const listBusinessInvitationsByBusinessId = async (
  businessId: string,
): Promise<InvitationWithDestinationDetails[]> => {
  const { data } = await apiV2.get<InvitationWithDestinationDetails[]>(
    `invitations/business/${businessId}`,
  );
  return data;
};

export const createInvitation = async (
  invitation: Partial<Invitation>,
): Promise<Partial<Invitation>> => {
  const { data } = await apiV2.post<Partial<Invitation>>(
    'invitations',
    invitation,
  );
  return data;
};

export const updateInvitation = async (
  id: string,
  invitation: Partial<Invitation>,
): Promise<Partial<Invitation>> => {
  const { data } = await apiV2.put<Partial<Invitation>>(
    `invitations/${id}`,
    invitation,
  );
  return data;
};

export const resendInvitation = async (id: string): Promise<void> => {
  await apiV2.put(`invitations/${id}/resend`);
};

export const acceptInvitation = async (id: string): Promise<void> => {
  await apiV2.put(`invitations/${id}/accept`);
};

export const declineInvitation = async (id: string): Promise<void> => {
  await apiV2.put(`invitations/${id}/decline`);
};

export const voidInvitation = async (id: string): Promise<void> => {
  await apiV2.put(`invitations/${id}/void`);
};

export const listHouseholdInvitationsByHouseholdId = async (
  householdId: string,
): Promise<InvitationWithDestinationDetails[]> => {
  const { data } = await apiV2.get<InvitationWithDestinationDetails[]>(
    `invitations/household/${householdId}`,
  );
  return data;
};
